import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 0H3v24h18V0zm-7 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"
}), 'TabletAndroidSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TabletAndroidSharp.js
// module id = 6682
// module chunks = 2